import Swiper from 'swiper'

const SELECTORS = {
    griditem: '.griditem'
}

const CLASSES = {
}

export default class GridItemSlider {
    constructor () {
        this.isLoaded = false
    }

    initialize () {
        this.elems = Array.from( document.querySelectorAll(SELECTORS.griditem) )
        this.isInit()
    }

    init () {
        const t = this

        const initSwiperForElem = elem => {
            const swiperCn = elem.querySelector('.swiper-container')
            if ( !swiperCn ) return

            const swiperCurrent = swiperCn.querySelector('.griditem__current__text')
            const swiperCircle  = swiperCn.querySelector('.griditem__current__circle .shape')

            var mySwiper = new Swiper(elem.querySelector('.swiper-container'), {
                // direction: 'horizontal',// 'vertical'
                speed: variables.transition,
                effect: 'slide',// Could be "slide", "fade", "cube", "coverflow" or "flip"
                grabCursor: true,

                slidesPerView: 1,// number or 'auto'

                // freeMode: true,
                // freeModeSticky: true,

                watchSlidesProgress: true,

                loop: true,

                autoplay: {
                    delay: 5000
                },

                navigation: {
                  nextEl: elem.querySelector('.swiper-button-next'),
                  prevEl: elem.querySelector('.swiper-button-prev'),
                },

                on: {
                    slideChange: () => {
                        if ( !swiperCurrent || !mySwiper ) return
                        swiperCurrent.innerHTML = mySwiper.realIndex + 1
                    },
                    slideChangeTransitionStart: () => {
                        if ( !swiperCircle ) return
                        Util.addClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 120)
                    },
                    slideChangeTransitionEnd: () => {
                        if ( !swiperCircle ) return
                        Util.removeClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 0)
                    },
                    touchStart: () => {
                        if ( !swiperCircle ) return
                        Util.addClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 120)
                    },
                    touchEnd: () => {
                        if ( !swiperCircle ) return
                        Util.removeClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 0)
                    },
                    autoplayStart: () => {
                        if ( !swiperCircle ) return
                        Util.removeClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 0)
                    },
                    autoplayStop: () => {
                        if ( !swiperCircle ) return
                        Util.addClass(swiperCircle, 'noAnim')
                        swiperCircle.setAttribute('stroke-dashoffset', 120)

                    }
                }
            })
            mySwiper.autoplay.stop()

            elem.addEventListener('mouseenter', function() {
                mySwiper.autoplay.start()
            })
            elem.addEventListener('mouseleave', function() {
                mySwiper.autoplay.stop()
            })

            // Delay the start of the slider for 0-5s
            // setTimeout(() => {
            //     mySwiper.autoplay.start()
            // }, Math.floor(Math.random() * 5) * 1000)
        }

        this.elems.forEach( item => initSwiperForElem(item) )
    }

    isInit () {
        this.isLoaded = true
        App.loadProgress += 1
        App.checkAppLoaded()
    }
}
